import { Page } from "../translations/types";
import { FILTER_COLUMNS_TRANSLATIONS } from "../translations/util";

export const XSSI_FILTER_COLUMNS = [
  {
    id: "CONNECTION-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.XSSI_CONNECTION]["CONNECTION-ID"],
  },
  {
    id: "RADIO-IPV4-ADDR",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"],
  },
  {
    id: "RADIO-RFSS-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-RFSS-ID"],
  },
  {
    id: "RADIO-SYSTEM-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-SYSTEM-ID"],
  },
  {
    id: "RADIO-WACN-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-WACN-ID"],
  },
];
export const P25_GROUP_FILTER_COLUMNS = [
  { id: "RFSS", value: FILTER_COLUMNS_TRANSLATIONS[Page.P25_GROUP].RFSS },
  {
    id: "TARGET-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.P25_GROUP]["TARGET-ID"],
  },
];
export const FIXED_NETWORK_ELEMENT_FILTER_COLUMNS = [
  {
    id: "RFSS",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT].RFSS,
  },
  {
    id: "TARGET-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.FIXED_NETWORK_ELEMENT]["TARGET-ID"],
  },
];
export const LMR_GROUPS_FILTER_COLUMNS = [
  { id: "TG-ID", value: FILTER_COLUMNS_TRANSLATIONS[Page.LMR_GROUP]["TG-ID"] },
  {
    id: "MAPPED-MCPTT-GID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.LMR_GROUP]["MAPPED-MCPTT-GID"],
  },
  {
    id: "LMR-NW-TYPE",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.LMR_GROUP]["LMR-NW-TYPE"],
  },
];
export const DFSI_CONNECTIONS_FILTER_COLUMNS = [
  {
    id: "CONNECTION-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.DFSI_CONNECTION]["CONNECTION-ID"],
  },
];
export const LMR_USERS_FILTER_COLUMNS = [
  { id: "LMR-ID", value: FILTER_COLUMNS_TRANSLATIONS[Page.LMR_USER]["LMR-ID"] },
  {
    id: "LMR-NW-TYPE",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.LMR_USER]["LMR-NW-TYPE"],
  },
  {
    id: "MAPPED-MCPTT-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.LMR_USER]["MAPPED-MCPTT-ID"],
  },
  {
    id: "DISPLAY-NAME",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.LMR_USER]["DISPLAY-NAME"],
  },
  {
    id: "MUTUAL-AID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.LMR_USER]["MUTUAL-AID"],
  },
];
export const MCPTT_GROUPS_FILTER_COLUMNS = [
  {
    id: "MCPTT-GID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_GROUP]["MCPTT-GID"],
  },
  {
    id: "MAPPED-P25-TG-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_GROUP]["MAPPED-P25-TG-ID"],
  },
  {
    id: "MAPPED-DMR-TG-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_GROUP]["MAPPED-DMR-TG-ID"],
  },
  {
    id: "MAPPED-ROIP-TG-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_GROUP]["MAPPED-ROIP-TG-ID"],
  },
  {
    id: "MAPPED-DFSI-TG-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_GROUP]["MAPPED-DFSI-TG-ID"],
  },
];
export const MCPTT_USERS_FILTER_COLUMNS = [
  {
    id: "MCPTT-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_USER]["MCPTT-ID"],
  },
  {
    id: "MAPPED-P25-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-P25-ID"],
  },
  {
    id: "MAPPED-DMR-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DMR-ID"],
  },
  {
    id: "MAPPED-ROIP-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-ROIP-ID"],
  },
  {
    id: "MAPPED-DFSI-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DFSI-ID"],
  },
  {
    id: "DISPLAY-NAME",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_USER]["DISPLAY-NAME"],
  },
  {
    id: "MUTUAL-AID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.MCPTT_USER]["MUTUAL-AID"],
  },
];
export const OTAR_FILTER_COLUMNS = [
  {
    id: "CONNECTION-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.OTAR_CONNECTION]["CONNECTION-ID"],
  },
  {
    id: "KMF-RADIO-SET-IDENTIFIER",
    value:
      FILTER_COLUMNS_TRANSLATIONS[Page.OTAR_CONNECTION][
        "KMF-RADIO-SET-IDENTIFIER"
      ],
  },
];
export const CANNED_MESSAGES_FILTER_COLUMNS = [
  {
    id: "MSG-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.CANNED_MESSAGE]["MSG-ID"],
  },
  {
    id: "CANNED-TEXT",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.CANNED_MESSAGE]["CANNED-TEXT"],
  },
];
export const ORGANIZATION_FILTER_COLUMNS = [
  {
    id: "Organisation ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG]["Organisation ID"],
  },
  {
    id: "Organisation Name",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG]["Organisation Name"],
  },
];
export const ORGANIZATION_TRANSLATION_FILTER_COLUMNS = [
  { id: "ID", value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG_TRANSLATION].ID },
  {
    id: "EFI",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG_TRANSLATION].EFI,
  },
  {
    id: "EFO",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG_TRANSLATION].EFO,
  },
  {
    id: "FROM",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG_TRANSLATION].FROM,
  },
  { id: "TO", value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG_TRANSLATION].TO },
];
export const ORGANIZATION_MAPPING_FILTER_COLUMNS = [
  {
    id: "IWF-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG_MAPPING]["IWF-ID"],
  },
  {
    id: "ORG-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.ORG_MAPPING]["ORG-ID"],
  },
];
export const LOCATIONS_FILTER_COLUMNS = [
  { id: "IWF ID", value: FILTER_COLUMNS_TRANSLATIONS[Page.LOCATION]["IWF ID"] },
  {
    id: "IWF Location Name",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.LOCATION]["IWF Location Name"],
  },
  {
    id: "IWF Domain Name",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.LOCATION]["IWF Domain Name"],
  },
];
export const REALTIME_FILTER_COLUMNS = [
  {
    id: "GROUP-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.PUBLISH_INFO]["GROUP-ID"],
  },
  {
    id: "USER-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.PUBLISH_INFO]["USER-ID"],
  },
];
export const P25_UNIT_FILTER_COLUMNS = [
  { id: "RFSS", value: FILTER_COLUMNS_TRANSLATIONS[Page.P25_UNIT].RFSS },
  {
    id: "TARGET-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.P25_UNIT]["TARGET-ID"],
  },
];
export const P25_AFFILIATIONS_FILTER_COLUMNS = [
  {
    id: "RFSS",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.P25_AFFILIATIONS].RFSS,
  },
  {
    id: "TARGET-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.P25_AFFILIATIONS]["TARGET-ID"],
  },
];

export const IKI_FILTER_COLUMNS = [
  {
    id: "CONNECTION-ID",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.IKI_CONNECTION]["CONNECTION-ID"],
  },
  {
    id: "IKI-IPV4-ADDR",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-IPV4-ADDR"],
  },
  {
    id: "IKI-PORT",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-PORT"],
  },
  {
    id: "IKI-NAME",
    value: FILTER_COLUMNS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-NAME"],
  },
];
